import { Outlet } from 'react-router-dom';
import { withPermission } from '../withPermission';

export const ProviderDetails = withPermission('canViewProviders', () => {
  return <Outlet />;
});
